import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function Reports() {
  return (
    <Box sx={{ p: { xs: 1, md: 3 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Typography variant="h4" gutterBottom fontWeight={700} color="text.primary">
        Reports & Analytics
      </Typography>
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="body1">Reports and analytics will app/Appear here.</Typography>
      </Paper>
    </Box>
  );
} 
